import SWIPE_ANIMATION from './swipe.json';

export const options = {
  animationData: SWIPE_ANIMATION,
  loop: true,
};
